import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useReportStore } from '../../Stores/reportStore'
import { SESSION_STORAGE } from '../../constants/sessionStorage'
import { useURL } from '../../hooks/hydration/useURL'
import { useNewSimulation } from '../../hooks/useNewSimulation'
import { t } from '../../i18n'
import { EditIcon, Relatorio } from '../Icons'
import { ReportSimulationModal } from '../ReportSimulationModal/ReportSimulationModal'
import { ActionContainer, ActionText } from './styles'

export function SubHeader() {
  const { handleUpdateURLWithReload } = useURL()
  const [showReportSimulation, setShowReportSimulation] = useState(false)
  const elementPortal = document.getElementsByTagName('body')?.[0]
  const { setSimulationLocalStorage } = useNewSimulation()
  const { isReportGeneratedEnabled } = useReportStore()

  const newSimulation = () => {
    sessionStorage.removeItem(SESSION_STORAGE.rpsQuoteId)
    localStorage.removeItem(SESSION_STORAGE.rpsQuoteId)

    setSimulationLocalStorage()
    handleUpdateURLWithReload()
  }

  const consultSimulationReport = () => {
    setShowReportSimulation(true)
  }

  return (
    <>
      <ActionContainer onClick={newSimulation}>
        <EditIcon width={24} height={24} />
        <ActionText>{t('general.newSimulation')}</ActionText>
      </ActionContainer>
      {!isReportGeneratedEnabled && (
        <ActionContainer onClick={consultSimulationReport}>
          <Relatorio size={22} />
          <ActionText>{t('general.simulationReport')}</ActionText>
        </ActionContainer>
      )}
      {createPortal(
        <>
          <ReportSimulationModal
            isVisible={showReportSimulation}
            closeAction={() => setShowReportSimulation(false)}
          />
        </>,
        elementPortal!,
      )}
    </>
  )
}
